import documentsicon from "../../../../../assets/images/description.svg";
import useDomesticHelperFlow from "../../../../../hooks/useDomesticHelperFlowSimple";
import useLanguageTranslate from "../../../../../hooks/useLanguageTranslate";
import DomesticHelperBottomStickyBtnLayout from "../../../layouts/DomesticHelperBottomStickyBtnLayout";
import DomesticHelperJourneyLayout from "../../../layouts/DomesticHelperJourneyLayout";
import "./documentsReadyInfo.css";
import InfoCard from "./infoCard";

const DocumentsReadyInfo = ({
  continueClickHandler,
  hide_back_btn,
  show_close_btn,
  onClose,
  customBackHandler,
}) => {
  const translate = useLanguageTranslate();
  const { handlePrevSubstep } = useDomesticHelperFlow();

  return (
    <div className="documents-ready-info w-full">
      <DomesticHelperJourneyLayout
        show_close_btn={show_close_btn}
        is_hide_back_btn={hide_back_btn}
        customBackHandler={
          !hide_back_btn ? customBackHandler || handlePrevSubstep : undefined
        }
        onClose={onClose}
      >
        <DomesticHelperBottomStickyBtnLayout
          btn_onClick={continueClickHandler}
          btn_label={translate("Continue", "التالي")}
        >
          <div className="w-[32%] max767:w-full mx-auto ipad:min-w-[66%] pb-5">
            <h1 className="text-[#1A2024] text-center text-2xl not-italic font-semibold leading-8 tracking-[-0.24px] max767:text-left max767:rtl:text-right">
              {translate(
                "Ready to Start Your New Policy?",
                "هل أنت مستعد لبدء وثيقتك الجديدة ؟"
              )}
            </h1>
            <p className="text-[#1A2024] text-center text-base not-italic font-normal leading-6 tracking-[-0.16px] mb-6 max767:text-left max767:rtl:text-right">
              {translate(
                "Please ensure you have the following information and documents ready for smooth process.",
                "يرجى التأكد من أن لديك المعلومات والمستندات التالية جاهزة لعملية سلسة."
              )}
            </p>
            <div className="infoCards mb-6 space-y-4">
              <InfoCard
                title={translate(
                  "Required Documents",
                  "الوثائق المطلوبة للحصول على تأشيرة جديدة"
                )}
                title_icon={documentsicon}
                infoData={[
                  {
                    en_label: "Domestic helper passport copy",
                    ar_label: "نسخة من جواز سفر العامل المنزلي",
                    hasInfo: false,
                  },
                  {
                    en_label: "CPR or Passport of the Beneficiary",
                    ar_label: "بطاقة الهوية أو جواز سفر المستفيد",
                    hasInfo: false,
                  },
                  {
                    en_label: "Valid Work Permit",
                    ar_label: "تصريح عمل ساري",
                    hasInfo: false,
                  },
                ]}
              />
            </div>

            {/* Warning Note */}
            <div className="bg-[#FDE9D2] border border-[#FBC98E] rounded-lg p-4 flex items-start mb-6">
              <div className="flex-shrink-0 mr-3 rtl:mr-0 rtl:ml-3">
                <svg
                  className="w-5 h-5 text-[#A56213]"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="flex-1">
                <p className="text-[#252C32] text-sm font-semibold">
                  {translate(
                    "Please note policy periods should be in line with work permit duration of 1 or 2 years as per LMRA specifications.",
                    "يرجى ملاحظة أن فترات الوثيقة يجب أن تتماشى مع مدة تصريح العمل التي تتراوح بين سنة أو سنتين وفقًا لمواصفات هيئة تنظيم سوق العمل (LMRA)."
                  )}
                </p>
              </div>
            </div>
          </div>
        </DomesticHelperBottomStickyBtnLayout>
      </DomesticHelperJourneyLayout>
    </div>
  );
};

export default DocumentsReadyInfo;
